import { Seo } from "../lib/seo";
import { ContactForm } from "../components/ContactForm";

export const Contact = () => (
  <>
    <Seo
      title="Contact"
      description="Talk to Bancony about a pilot, a demo, the compliance pack, or an EU AI Act readiness call."
      path="/contact"
    />

<section className="page-hero" data-section="contact-hero">
      <div className="page-hero-inner">
        <span className="section-eyebrow">Contact</span>
        <h1>Talk to us about a pilot.</h1>
        <p className="page-hero-sub">
          Tell us a bit about your bank and what you're looking for. We'll come back to
          you with a 30-minute call slot and, if useful, the relevant materials in advance.
        </p>
      </div>
    </section>

    <section className="section" data-section="contact-form">
      <div className="section-inner">
        <div className="contact-grid">
          <ContactForm />
          <aside className="contact-meta">
            <h4>Email</h4>
            <p><a href="mailto:hello@bancony.com">hello@bancony.com</a></p>

            <h4>Press</h4>
            <p><a href="mailto:press@bancony.com">press@bancony.com</a></p>

            <h4>Office</h4>
            <p>Smáratorg 3<br />201 Kópavogur<br />Iceland</p>

            <h4>Trying the demo</h4>
            <p>
              Ask for demo credentials and we'll send you a retail and a corporate test
              user.{" "}
              <a href="https://demo.bancony.com/" target="_blank" rel="noopener noreferrer">
                demo.bancony.com
              </a>{" "}
              walks you through both products step by step.
            </p>

            <h4>What happens next</h4>
            <p>
              You'll receive a reply from a human within one working day. If your message
              names a specific deadline (AI Act scope review, pilot dates), we prioritise it.
            </p>
          </aside>
        </div>
      </div>
    </section>
  </>
);
